import { render, staticRenderFns } from "./AccountFormsView.vue?vue&type=template&id=2cfa7a56&scoped=true"
import script from "./AccountFormsView.js?vue&type=script&lang=js&external"
export * from "./AccountFormsView.js?vue&type=script&lang=js&external"
import style0 from "./AccountFormsView.vue?vue&type=style&index=0&id=2cfa7a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfa7a56",
  null
  
)

export default component.exports